import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

// update log
// FB 6751 SK    05/31/2023    Mis-Directed URL: https://aaron.mdchartsportal.com/

export default function InvalidSite() {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    window.open("about:blank", "_self");
    window.close();
  };
  React.useEffect(() => {
    setTimeout(function () {
      handleClickOpen();
    }, 2000);
  }, []);

  return (
    <div>
      <Dialog
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Invalid Website"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Unknown MD Charts site. Please enter valid URL
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} autoFocus>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
